import { theme } from '../../styles/theme';
import { focusOutline } from '../../styles/focus';

export const dialogWrapperContainer = {
  padding: {
    mobile: '64px 24px',
    tablet: '64px'
  },
  width: {
    mobile: '100%',
    tablet: '800px'
  },
  height: 'auto',
  zIndex: '1301',
  position: 'relative'
};

export const dialogWrapper = {
  '@media (orientation: landscape) and (min-width: 500px)': {
    '.MuiPaper-root': {
      maxHeight: 'unset',
      width: '70%'
    }
  }
};

export const dialogWrapperSubtitle = {
  color: theme.palette.common.violet,
  fontSize: '14px',
  letterSpacing: '2.6px',
  textTransform: 'uppercase'
};

export const dialogWrapperTitle = {
  fontSize: '36px',
  lineHeight: 1.2,
  fontWeight: 800,
  color: theme.palette.common.darkGrey1,
  fontFamily: 'Epilogue, sans-serif;'
};

export const dialogWrapperClose = {
  cursor: 'pointer',
  '&:focus-visible': focusOutline
};
